// @flow

import React from 'react';
import Translate from 'client/components/translate';
import PictureCard from 'client/components/card/pictureCard';
import Stars from 'client/components/stars';

type Props = {
  testimonials: Array<{
    quote: string,
    title: string,
    author: string,
    imgSrc: string,
    quotePath: string,
    titlePath: string,
    authorPath: string,
    imgSrcPath: string,
  }>,
};

const Testimonials = (props: Props) => {
  const { testimonials } = props;
  const columnWidth = testimonials.length && testimonials.length > 0 ? 12 / testimonials.length : 6;

  return (
    <div className="testimonials row center-col collapse">
      {testimonials.map(testimonial => (
        <div
          className={`column ${columnWidth >= 6 ? 'medium' : 'large'}-${columnWidth}`}
          key={testimonial.imgSrc}>
          <PictureCard className="white-bg" pictureSrcs={[testimonial.imgSrc]}>
            <div className="pad-top-2">
              <div style={{ fontStyle: 'italic' }}>
                {testimonial.quotePath ? (
                  <Translate path={testimonial.quotePath} />
                ) : (
                  <span>{testimonial.quote}</span>
                )}
              </div>
              <div className="pad-top">
                <div>
                  {testimonial.authorPath ? (
                    <Translate path={testimonial.authorPath} />
                  ) : (
                    <span>{testimonial.author}</span>
                  )}
                </div>
                {(testimonial.titlePath || testimonial.title) && (
                  <div className="sub grey-3-color">
                    {testimonial.titlePath ? (
                      <Translate path={testimonial.titlePath} />
                    ) : (
                      <span>{testimonial.title}</span>
                    )}
                  </div>
                )}
              </div>
              <Stars className="pad-top" />
            </div>
          </PictureCard>
        </div>
      ))}
    </div>
  );
};

export default Testimonials;
